import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Antes de renderizar: apunta Monaco a los archivos servidos por esta misma imagen en
// vez del CDN. Tiene que correr antes de que monte cualquier editor. Ver utils/monaco.js.
import './utils/monaco';
// import 'utils';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();

const intervalID = setInterval(()=>{
try{ // TODO: reemplazar esto por correcta implementacion
  window.forzarUpdate()
}catch(err){}

}, 2000);